import {CommonModule} from '@angular/common';
import {AfterContentChecked, ChangeDetectorRef, Component} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {NgProgressbar} from 'ngx-progressbar';
import {BehaviorSubject, Observable} from 'rxjs';
import {filter} from 'rxjs/operators';
import {Ausschreibung} from '../../model/ausschreibung';
import {TenantConfig} from '../../model/tenant-config';
import {AusschreibungService} from '../../service/ausschreibung.service';
import {PageTitleService} from '../../service/page-title.service';
import {TenantConfigService} from '../../service/tenant-config.service';
import {StzhHeaderComponent} from '../stzh-header/stzh-header.component';

@Component({
    imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, NgProgressbar, StzhHeaderComponent],
    selector: 'dah-stzh-layout',
    templateUrl: './stzh-app-layout.component.html',
    styleUrls: ['./stzh-app-layout.component.css'],
    standalone: true
})
export class StzhAppLayoutComponent implements AfterContentChecked {
  year = new Date().getFullYear();
  selectedAusschreibungTitle = '';
  id = '-1';
  angebot = false;
  signedIn = false;
  isLanding = false;
  tenant: TenantConfig = this.tenantConfigService.current;

  public selected: Observable<Ausschreibung | undefined>;
  pageTitle: BehaviorSubject<string>;

  constructor(
    private ausschreibungService: AusschreibungService,
    private changeDetector: ChangeDetectorRef,
    private router: Router,
    private tenantConfigService: TenantConfigService,
    pageTitleService: PageTitleService,
  ) {
    this.pageTitle = pageTitleService.get();
    const checkLanding = (url: string) => url.split(/[?#]/)[0] === '/landing';
    this.isLanding = checkLanding(this.router.url);
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    ).subscribe(e => this.isLanding = checkLanding(e.urlAfterRedirects));

    this.ausschreibungService.isSignedIn().subscribe(signedIn => this.signedIn = signedIn);

    this.selected = this.ausschreibungService.get();
    this.selected.subscribe(next => {
      if (!next) return;
      this.selectedAusschreibungTitle = next.objekt ?? '';
      this.id = next.id ?? '-1';
      this.angebot = next.angebot !== undefined;
    });
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  addBaseUrl = (path: string) => this.ausschreibungService.addBaseUrl(path);
}
